import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © All Rights Reserved By<a> TrainTab</a> 2023
        </p>
      </div>
    </div>
  );
};

export default Footer;
